import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IValidarIban } from '@interfaces/validar-iban.interface';
import { InsuranceService } from 'src/app/core/services/insurance.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'aig-modal-edit-iban',
  imports: [ModalComponent, FormsModule],
  templateUrl: './modal-edit-iban.component.html',
  styleUrl: './modal-edit-iban.component.scss',
})
export class ModalEditIbanComponent {
  //#region INPUTS & OUTPUTS
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() validationResult: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() lastDigits: string | null = null;
  @Input() IdPoliza: number | null = null;

  //#endregion

  //#region VARIABLES

  public digitsRequired: string = '';

  //#endregion
  constructor(private insuranceService: InsuranceService) {}

  // #region METHODS
  public checkIfCanChange(): boolean {
    let pattern = new RegExp('[0-9]{4}');

    return pattern.test(this.digitsRequired);
  }

  public acceptChange(): void {
    if (this.IdPoliza === null || this.lastDigits === null) {
      console.error('Error: IdPoliza o lastDigits es nulo');
      this.validationResult.emit(false);
      return;
    }

    const ibanValidar: string = this.digitsRequired + this.lastDigits;
    const datos: IValidarIban = { idPoliza: this.IdPoliza, iban: ibanValidar };

    this.insuranceService.validarIbanPoiza(datos).subscribe({
      next: (response) => {
        this.validationResult.emit(true);
        this.clickHide();
      },
      error: (error) => {
        console.error(error);
        this.validationResult.emit(false);
      },
    });
  }

  clickHide(): void {
    this.hideModal.emit(true);
  }
  //#endregion
}
